<template>
  <UiSection id="covid" class="bg-gradient-to-br from-green-200 to-gray-600">
    <div class="relative container mx-auto whitespace-normal space-y-10">
      <h2 class="text-5xl font-extrabold">COVID-19</h2>
      <div class="space-y-4 -ml-1 pl-16 text-2xl">
        <div class="flex items-center">
          <span class="fa-stack fa-sm -ml-16 mr-2 flex-shrink-0">
            <i class="fas fa-square fa-stack-2x" />
            <i class="fas fa-thermometer-half fa-stack-1x fa-inverse" />
          </span>
          {{ t('temperature') }}
        </div>
        <div class="flex items-center">
          <span class="fa-stack fa-sm -ml-16 mr-2 flex-shrink-0">
            <i class="fas fa-square fa-stack-2x" />
            <i class="fas fa-head-side-mask fa-stack-1x fa-inverse" />
          </span>
          {{ t('mask') }}
        </div>
        <div class="flex items-center">
          <span class="fa-stack fa-sm -ml-16 mr-2 flex-shrink-0">
            <i class="fas fa-square fa-stack-2x" />
            <i class="fas fa-spray-can fa-stack-1x fa-inverse" />
          </span>
          {{ t('sanitizer') }}
        </div>
      </div>
    </div>
  </UiSection>
</template>

<script>
  import { useI18n } from 'vue-i18n'

  export default {
    name: 'SectionCovid',
    setup() {
      const { t } = useI18n({
        messages: {
          en: {
            temperature: 'Everyone will have their body temperature measured upon entrance.',
            mask: 'You must wear a mask.',
            sanitizer: 'Hand sanitizer will be provided.',
          },
          ru: {
            temperature: 'У всех на входе будет измеряться температура тела.',
            mask: 'Вы обязаны носить маску.',
            sanitizer: 'Антисептик для рук будет предоставлен.',
          },
        },
      })

      return { t }
    },
  }
</script>
